import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <br />
    <h2>{`🏅 Skills`}</h2>
    <p>{`⚡ `}<strong parentName="p">{`Programming languages`}</strong>{` : C, C++, Python, Nodejs `}</p>
    <p>{`⚡ `}<strong parentName="p">{`Platforms`}</strong>{` : Windows, Ubuntu 16.04 `}</p>
    <p>{`⚡ `}<strong parentName="p">{`Machine/Deep learning`}</strong>{` : Scikit-learn, Keras `}</p>
    <p>{`⚡ `}<strong parentName="p">{`Web Scraping`}</strong>{` : Scrapy framework and other python libraries.`}</p>
    <p>{`⚡ `}<strong parentName="p">{`Backend`}</strong>{` : Flask, Nodejs, PHP`}</p>
    <p>{`⚡ `}<strong parentName="p">{`Frontend`}</strong>{` : React, Vue, HTML, CSS, Twig templates, Bootstrap, SVG animations. `}</p>
    <p>{`⚡ `}<strong parentName="p">{`Blockchain technology`}</strong>{`: Ethereum , Hyperledger Sawtooth, Blockstack js`}</p>
    <p>{`⚡ `}<strong parentName="p">{`Others`}</strong>{` : VCS(Git), Arduino UNO `}</p>
    <br />
    {
      /* ### 🌌🛰🌌 */
    }

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      